import { BookIcon } from "@biblioteksentralen/icons";
import { Box, ChakraProps, Image, Skeleton } from "@biblioteksentralen/react";
import { ForrigeBokWork } from "@libry-content/integrations";
import { coverImageAltText } from "../../utils/coverImageAltText";
import { getAccentColorFromSeed } from "@libry-content/common";

interface Props extends ChakraProps {
  presentationData: ForrigeBokWork["simplifiedPresentationMetadata"];
}

const transformStyles = {
  transition: ".9s",
  _groupHover: { transition: ".5s", transform: "scale(0.965)" },
};

const CoverImage = ({ presentationData, ...chakraProps }: Props) => {
  const placeholderColor = getAccentColorFromSeed(presentationData.title);
  const altText = coverImageAltText(presentationData);

  if (!presentationData.coverImage) {
    return (
      <Box
        css={`
          aspect-ratio: 0.7;
        `}
        borderRadius="md"
        backgroundColor={placeholderColor}
        display="flex"
        justifyContent="center"
        color="white"
        alignItems="center"
        fontSize="2rem"
        width="100%"
        boxShadow="md"
        {...chakraProps}
        {...transformStyles}
      >
        <BookIcon aria-hidden />
      </Box>
    );
  }
  return (
    <Image
      fallback={
        <Skeleton
          css={`
            aspect-ratio: 0.7;
          `}
          speed={1.5}
          borderRadius="md"
          {...chakraProps}
        />
      }
      borderRadius="md"
      src={presentationData.coverImage}
      alt={altText}
      boxShadow="md"
      {...chakraProps}
      {...transformStyles}
    />
  );
};

export default CoverImage;
